<template>
    <div class="container">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>运费规则设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="query" ref="query">
                <el-form-item  label="运费规则设置" prop="ruleName" >
                    <el-input v-model="query.ruleName" placeholder="运费规则设置"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>规则设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="display: flex;">
                <div class="container-left">
                    <div class="container-header">地区导航</div>
                    <el-tree
                            :data="treeData"
                            :props="defaultProps"
                            @node-click="handleNodeClick"
                    >

                    </el-tree>
                </div>
                <div class="container-right">
                    <div class="container-header">运费规则设置</div>
                    <div class="container-content">
                        <el-form :inline="true" :model="query" ref="query">
                            <el-form-item  label="市区级" prop="cityAreaName" >
                                <el-input v-model="query.cityAreaName" placeholder="市区级名称"></el-input>
                            </el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                        </el-form>
                        <TableList
                                :table-data="tableData"
                                :table-label="tableLabel"
                                :loading="loading"
                        >
                            <template v-slot:isSale>
                                    <el-radio v-model="query.isSale" :label="1">是</el-radio>
                                    <el-radio v-model="query.isSale" :label="0">否</el-radio>
                            </template>
                        </TableList>
                    </div>

                    <div class="pagination">
                        <el-pagination
                                prev-text="上一页"
                                next-text="下一页"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="productTagPage.currentPage"
                                :page-size="productTagPage.pageSize"
                                :total="productTagPage.pageTotal"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>


        </div>

        <div class="container">
            <el-button type="primary" @click="handleConfirm" style="margin-left: 50%;display: inline-block">确定</el-button>
            <el-button @click="handleGoBack" style="display: inline-block">取消</el-button>
        </div>
    </div>
</template>

<script>
    import TableList from '../../../../components/common/table-list.vue'
    export default {
        name: "freightRulesAdd",
        components: {
            TableList
        },
        props: {},
        data() {
            return {
                query:{
                    ruleName:'',
                    cityAreaName:'',
                    isSale:0
                },
                treeData:[{
                    label: '河北省',
                    children: [{
                        label: '石家庄市',
                    },
                        {
                            label: '邢台市',
                        },
                        {
                            label: '沧州市'
                        }
                    ]
                }, {
                    label: '山东省',
                    children: [{
                        label: '济南市',
                    }, {
                        label: '青岛市',
                    }]
                }, {
                    label: '河南省',
                    children: [{
                        label: '郑州市',
                    }]
                }],
                defaultProps:{
                    children: 'children',
                    label: 'label'
                },
                tableData:[
                    {city:'石家庄',province:'河北省',isSale:0,money:12,freight:10}
                ],
                loading:false,
                tableLabel: [
                    { label: '市区级', param: 'city', align: 'center',fixed:'left'},
                    { label: '省级', param: 'province', align: 'center'},
                    { label: '是否可售', param: 'isSale', align: 'center'},
                    { label: '包邮金额(元)', param: 'money', align: 'center' },
                    { label: '运费(元)', param: 'freight', align: 'center' },
                ],
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
            }
        },
        computed: {},
        created() {
        },
        methods: {
            handleNodeClick(){

            },
            handleSearch(){

            },
            handleGoBack(){

            },
            handleConfirm(){

            },
            handleSizeChange(){

            },
            handleCurrentChange(){

            }
        }

    }
</script>

<style lang="scss" scoped>
    .container-left{
        display: inline-block;
        border: 1px solid #97a8be;
        width: 200px;
        min-height: 400px;
        margin-right: 20px;
        .container-header{
            width: 100%;
            height: 40px;
            background: #97a8be;
            text-align: center;
            line-height: 40px;
        }
    }
    .container-right{
        display: inline-block;
        width: 1200px;
        min-height: 400px;
        border: 1px solid #97a8be;
        .container-header{
            width: 100%;
            height: 40px;
            background: #97a8be;
            line-height: 40px;
            padding-left: 10px;
        }
        .container-content{
            width: 100%;
            min-height: 360px;
            padding: 20px;
            /*padding-left: 10px;*/
        }

    }
</style>
